"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteValueFromDataset = void 0;
var data_model_1 = require("@rdfjs/data-model");
function deleteValueFromDataset(target, key, dataset, contextUtil) {
    var nodesToRemove = [];
    if (key === "@context") {
        return true;
    }
    if (key === "toString" || key === Symbol.toStringTag) {
        return true;
    }
    if (typeof key === "symbol") {
        return true;
    }
    var subject = target["@id"];
    var predicate = (0, data_model_1.namedNode)(contextUtil.keyToIri(key));
    if (key === "@id") {
        nodesToRemove.push(target["@id"]);
    }
    else {
        var objectDataset = dataset.match(subject, predicate);
        if (objectDataset.size === 0) {
            return true;
        }
        else {
            nodesToRemove.push.apply(nodesToRemove, __spreadArray([], __read(objectDataset.toArray().map(function (quad) { return quad.object; })), false));
        }
    }
    nodesToRemove.forEach(function (term) {
        if (term.termType === "Literal") {
            dataset.delete((0, data_model_1.quad)(subject, predicate, term));
            return true;
        }
        else if (term.termType === "NamedNode") {
            dataset.deleteMatches(term, undefined, undefined);
            dataset.deleteMatches(undefined, undefined, term);
            return true;
        }
    });
    return true;
}
exports.deleteValueFromDataset = deleteValueFromDataset;
